export default __webpack_public_path__ + "static/media/loginbg.be96e271.png";